import {
  GET_REPORTS,
  PROPOSAL_BY_SELLER,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  SEARCH_ASSOCIATES,
} from './actionType';

// common success
export const ReportsApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ReportsApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetReports = () => ({
  type: GET_REPORTS,
});

export const ProposalBySeller = (data) => ({
  type: PROPOSAL_BY_SELLER,
  payload: { data },
});

export const SearchAssociates = (data) => ({
  type: SEARCH_ASSOCIATES,
  payload: { data },
});
